// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__hKApp","fileBtn":"File_fileBtn__2V0px","closeBtn":"File_closeBtn__16DkP","fileSelected":"File_fileSelected__teEKa","disabled":"File_disabled__3lDm7"};